module.exports = {
    footer: {
        customerServiceLinks: [
            ['Customer Service'],
            ['Product Safety', '/shop/discover/about-us/product-safety'],
            ['Product Recalls', '/shop/discover/about-us/product-recalls'],
            ['Scam Warning', '/shop/discover/about-us/scam-alert'],
            ['Help & Support', '/shop/page/help-and-support-faq'],
            ['Feedback', '/shop/page/help-and-support-faq'],
            ['Contact Us', '/shop/discover/about-us/contact-us'],
            ['Return Policy', '/shop/discover/about-us/returns-policy'],
            [
                'Offers & Competitions',
                '/shop/discover/about-us/offers-and-competitions',
            ],
            ['Accessibility', '/shop/support/accessibility'],
        ],
        generalServiceLinks: [
            ['Services'],
            ['Delivery', '/shop/discover/shopping-online/delivery'],
            ['Click & Collect', '/shop/discover/shopping-online/click-collect'],
            [
                'New to our Store?',
                '/shop/discover/shopping-online/new-to-online',
            ],
            ['My Business', '/shop/discover/shopping-online/my-business'],
            ['Community Donations', '/shop/discover/community-donations'],
        ],
        toolsLinks: [
            ['Tools'],
            ['Delivery Saver', '/shop/discover/shopping-online/delivery-saver'],
            ['Track My Order', '/shop/trackmyorder'],
            ['Woolworths Apps', '/shop/discover/about-us/woolworths-app'],
            ['Vendors', 'http://www.wowlink.com.au/wps/portal'],
            [
                'Woolworths Flowers',
                'http://www.woolworthsflowers.com.au/home.aspx',
            ],
            ['WOW Careers', 'http://www.wowcareers.com.au/'],
        ],
        aboutUsLinks: [
            ['About Us'],
            ['Our Stores', '/shop/storelocator'],
            ['Our Brands', '/shop/discover/our-brands'],
            ['Affiliates', '/shop/discover/about-us/partner-program'],
            ['Clubs'],
            ['Woolworths Rewards', 'https://www.woolworthsrewards.com.au/'],
            [
                'Baby and Toddler Club',
                'https://woolworthsbabyandtoddlerclub.com.au/',
            ],
        ],
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/footer.js